import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// TODO: Replace with your app's Firebase project configuration
// For now, using placeholders. User/Dev needs to replace this.

const firebaseConfig = {
    apiKey: "AIzaSyD9kzcEvgYkWpUjQWHIdSq2l0bCqi17DTY",
    authDomain: "dingit-dd1e5.firebaseapp.com",
    projectId: "dingit-dd1e5",
    storageBucket: "dingit-dd1e5.firebasestorage.app",
    messagingSenderId: "397855787052",
    appId: "1:397855787052:web:4444bb3951cf8c77b56989",
    measurementId: "G-M17NP1EFQ2"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);


